export default __webpack_public_path__ + "static/media/history_1950_00.2ba1a953.png";